const t = {
  name: "BatteryWrong",
  dimensions: { width: 40, height: 22 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4970)">
    <path d="M38 5.45005H35V2.52216C35 1.41158 34.1 0.50293 33 0.50293H2C0.9 0.50293 0 1.41158 0 2.52216V19.4837C0 20.5943 0.9 21.5029 2 21.5029H33C34.1 21.5029 35 20.5943 35 19.4837V16.5558H38C39.1 16.5558 40 15.6472 40 14.5366V7.46928C40 6.3587 39.1 5.45005 38 5.45005ZM33 19.4837H3C2.45 19.4837 2 19.0294 2 18.4741V2.52216H32C32.55 2.52216 33 2.97649 33 3.53178V7.46928V14.5366V19.4837ZM38 14.5366H36C35.45 14.5366 35 14.0823 35 13.527V7.46928H37C37.55 7.46928 38 7.9236 38 8.47889V14.5366Z"/>
    <path d="M20.7103 7.66104C20.3203 7.26729 19.6903 7.26729 19.3003 7.66104L17.5003 9.47834L15.7103 7.67113C15.3203 7.27738 14.6903 7.27738 14.3003 7.67113C13.9103 8.06488 13.9103 8.70094 14.3003 9.09469L16.0903 10.9019L14.3003 12.7091C13.9103 13.1029 13.9103 13.7389 14.3003 14.1327C14.5003 14.3346 14.7503 14.4255 15.0103 14.4255C15.2703 14.4255 15.5203 14.3245 15.7203 14.1327L17.5103 12.3255L19.3003 14.1327C19.5003 14.3346 19.7503 14.4255 20.0103 14.4255C20.2703 14.4255 20.5203 14.3245 20.7203 14.1327C21.1103 13.7389 21.1103 13.1029 20.7203 12.7091L18.9303 10.9019L20.7203 9.09469C21.1003 8.70094 21.1003 8.05479 20.7103 7.66104Z"/>
    </g>
    <defs>
    <clipPath id="clip0_12_4970">
    <rect width="40" height="21" fill="white" transform="translate(0 0.50293)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  t as BatteryWrong
};
